module.exports = __webpack_public_path__ + "img/鼎锐联监控管理软件.6c43ceb3.png";